var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popupComponent":_vm.popupComponent,"basic-data":_vm.basicData,"sort":"id","descending":true,"title":"Site List","icon":"mdi-sitemap","addButtonText":"Site","stateendpoint":"site.sites","actions":_vm.actions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }